
import { createReducer, on } from '@ngrx/store';

import { toRecord } from 'src/app/state/helpers/to-record';
import { FacilitiesActions } from '../actions/facilities/facilities-action-types';

import { FacilitiesState } from '../interfaces/facilities';

export const initialFacilitiesState: FacilitiesState = Object.freeze<FacilitiesState>({
    mine: [],
    models: {}, 
    activeModel: undefined
});

export const facilitiesReducer = createReducer(
    initialFacilitiesState,
    on(FacilitiesActions.fetchMyFacilitiesSuccess, (state, { models }) => ({
        ...state,
        models: { ...state.models, ...toRecord(models, f => f._id) },
        mine: models.map(f => f._id)
    })),
    on(FacilitiesActions.fetchFacilityByIdSuccess, (state, { model }) => ({
        ...state,
        models: {
            ...state.models,
            [model._id]: { ...model }
        }
    })),
    on(FacilitiesActions.fetchActiveFacilityModelSuccess, (state, {model})=>({
        ...state, 
        activeModel: model, 
    })),
    on(FacilitiesActions.editFacilitySuccess, (state, { model }) => ({
        ...state,
        activeModel:{...model, managers:state.activeModel.managers, supervisors: state.activeModel.supervisors}
    })),
    on(FacilitiesActions.addSupervisorSuccess, (state, { model }) => ({
        ...state,
        activeModel:{...state.activeModel, supervisors: model.supervisors}
    })),
    on(FacilitiesActions.uploadAvatarSuccess, (state, { model }) => ({
        ...state,
        activeModel:{...state.activeModel, avatar: model.avatar},
        models: {
            ...state.models,
            [model._id]: { ...state.models[model._id], avatar: model.avatar }, 
        }
    })),
    on(FacilitiesActions.createShiftTemplateSuccess, FacilitiesActions.editShiftTemplateSuccess, FacilitiesActions.deleteShiftTemplateSuccess, (state, { model }) => ({
        ...state,
        activeModel:{...state.activeModel, shiftTemplates: model.shiftTemplates}
    }))
);
